var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CButton',_vm._b({attrs:{"variant":_vm.variant,"color":_vm.color},on:{"click":_vm.copyElement}},'CButton',_vm.$attrs,false),[_c('CIcon',{attrs:{"name":"cil-copy"},on:{"click":_vm.copyElement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }